import { AccountType } from '../__generated__/pge-types';
import useGetAccountType from './useGetAccountType';

export function useAccountCustomerDashboard() {
  const { accountTypeData, loading: accountTypeLoading } = useGetAccountType(
    {},
  );
  const accountType =
    accountTypeData &&
    accountTypeData.getAccountDetails &&
    accountTypeData?.getAccountDetails[0]?.accountType;
  const isResAccount = accountType === AccountType?.Res;

  const loading = accountTypeLoading;

  return {
    isResAccount,
    loading,
  };
}
